import Genova1 from '../../Media/Logo Asya/Genova.png'
import Genova2 from '../../Media/Logo Asya/Genova.png'


const cluster1images =[
Genova1,Genova2
]

export default cluster1images;